export default () => {
  const btn = document.getElementById('js-hamburger');
  const btnInner = btn.firstElementChild;
  const nav = document.getElementById('js-navigation');
  const label = btnInner.innerText;
  const ico = getComputedStyle(btn).backgroundImage || false;
  const body = document.getElementsByTagName('body');

  // アクセシビリティ属性の設定

  btn.setAttribute('aria-pressed', false);
  btn.setAttribute('aria-controls', 'navigation');
  btn.setAttribute('aria-expanded', false);
  nav.setAttribute('aria-hidden', true);
  nav.setAttribute('aria-labelledby', 'hamburger');

  const event = (e) => {
    const target = e.currentTarget;

    if (!target.classList.contains('is-pressed')) {
      // クラスとアクセシビリティ属性の切り替え

      btn.classList.add('is-pressed');
      btn.setAttribute('aria-pressed', true);
      btn.setAttribute('aria-expanded', true);
      nav.classList.add('is-expanded');
      nav.setAttribute('aria-hidden', false);
      body[0].classList.add('is-filtered');

      btnInner.innerText = label.replace('開く', '閉じる');
    } else {
      // クラスとアクセシビリティ属性の切り替え

      btn.classList.remove('is-pressed');
      btn.setAttribute('aria-pressed', false);
      btn.setAttribute('aria-expanded', false);
      nav.classList.remove('is-expanded');
      nav.setAttribute('aria-hidden', true);
      body[0].classList.remove('is-filtered');

      btnInner.innerText = label.replace('閉じる', '開く');
    }
  };

  btn.addEventListener('click', event, false);

  window.addEventListener('load', () => {
    // アイコンのプリロード

    if (ico) {
      const url = ico.replace(/^url\(["']?/, '').replace('menu', 'close').replace(/["']?\)$/, '');
      const elm = document.createElement('img');
      elm.src = url;
    }
  });
};
